//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '../components/axios'
export default {
  data () {
    return {
        index:1,
        city:0,
        imglist:[],
        content:'',
        layout:'',
        id:0,
    }
  },
   watch: {
    // '$route' (to, from) {
    //     console.log('to',to);
    //     console.log('from',from);
    //   this.geturl();
    // }
  },
  created () {
      this.geturl();  
  },
  methods:{
      geturl:function(){ 
          var id=0;
      id=this.$route.query.city;
      var title='';
      if(typeof(id) === "undefined" || id === "undefined"){
          id=1;
      }
      
      if(id==1){
          title="星源简介";
      }
      if(id==3){
          title="研发实力";
      }
      if(id==4){
          title="合作伙伴";
      }
      this.id=id;
      window.document.title=title;
          let param = new URLSearchParams();
          param.append('id', this.id);
          util.ajax({
                    url: '/us/detail',
                    method: 'post',
                    params:param,
                }).then((res) => {
                    this.content=res.data.data.info;
                    this.layout=res.data.data.layout;
                    
                }).catch(function(err) {});
      },
  },
 
}



// WEBPACK FOOTER //
// ./src/view/about.vue